import React from 'react';
import { createBrowserRouter, createRoutesFromElements, Route, RouterProvider } from 'react-router-dom';
import { SnackbarProvider } from 'notistack';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from 'lib/react-query';
import { AuthProvider } from 'features/login';
import { Navigate } from 'react-router';
import GlobalErrorBoundary from 'components/GlobalErrorBoundary';
import { GridErrorBoundaryFallback } from 'features/cabinet';
import { CabinetRouter, LoginRouter, ServicesRouter } from 'routers';

const router = createBrowserRouter(
  createRoutesFromElements(
    <>
      {LoginRouter}
      <Route
        path="/"
        element={
          <GlobalErrorBoundary FallbackComponent={GridErrorBoundaryFallback}>
            <AuthProvider />
          </GlobalErrorBoundary>
        }
      >
        {ServicesRouter}
        {CabinetRouter}
        <Route path="*" element={<Navigate to="/services" />} />
        <Route path="" element={<Navigate to="/services" />} />
      </Route>
    </>,
  ),
);

const App = () => (
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <SnackbarProvider
        autoHideDuration={1000}
        maxSnack={1}
        anchorOrigin={{ horizontal: 'center', vertical: 'top' }}
        preventDuplicate
      >
        <GlobalErrorBoundary>
          <RouterProvider router={router} />
        </GlobalErrorBoundary>
      </SnackbarProvider>
    </QueryClientProvider>
  </React.StrictMode>
);

export default App;
